import swal from 'sweetalert2';
import { useEffect, useState } from 'react';
import { downloadUsers } from '../api/usersAPI';

// const EXPORT_COLUMNS_OLD = [
//     { label: 'Name',                    field: 'Name' },
//     { label: 'Active',                  field: 'Active' },
//     { label: 'Phone',                   field: 'Phone' },
//     { label: 'Address',                 field: 'Address' },
//     { label: 'City',                    field: 'City' },
//     { label: 'State',                   field: 'State' },
//     { label: 'Country',                 field: 'Country' },
//     { label: 'Pincode',                 field: 'Pincode' },
//     { label: 'Blood Group',             field: 'BloodGroup' },
//     { label: 'Nominee',                 field: 'Nominee' },
//     { label: 'PAN Card No',             field: 'PanCardNo' },
//     { label: 'Aadhar Card No',          field: 'AadharCardNo' },
//     { label: 'Membership Expires On',   field: 'MembershipExpiresOn' },
//     { label: 'Is Membership Expired',   field: 'IsMembershipExpired' },
//     { label: 'Is Subscription Expired', field: 'IsSubscriptionExpired' },
//     { label: 'Is Valid Member',         field: 'IsValidMember' },
//     { label: 'Subscription Code',       field: 'Code' },
//     { label: 'Subscription',            field: 'Subscription' },
// ];

const EXPORT_COLUMNS = [
    { label: 'Name',                    field: 'Name' },
    { label: 'MembershipTerm',          field: 'MembershipTerm' },
    { label: 'Category',                field: 'Category' },
    { label: 'CompanyName',             field: 'CompanyName' },
    { label: 'MembershipType',          field: 'MembershipType' },
    { label: 'MemberType',              field: 'MemberType' },
    { label: 'MembershipNo',            field: 'MembershipNo' },
    { label: 'Mobile',                  field: 'Mobile' },
    { label: 'Email',                   field: 'Email' },
    { label: 'Gender',                  field: 'Gender' },
    { label: 'Date Of Birth',           field: 'DOB' },
    { label: 'Subscription Expiry',     field: 'SubscriptionExpiresOn' },
    { label: 'Membership Expiry',       field: 'MembershipExpiresOn' },
    { label: 'Pan Card No',             field: 'PanCardNo' },
    { label: 'Aadhar No',               field: 'AadharCardNo' },
    { label: 'Address',                 field: 'Address' },
    { label: 'City',                    field: 'City' },
    { label: 'State',                   field: 'State' },
    { label: 'Country',                 field: 'Country' },
    { label: 'Pin Code',                field: 'Pincode' },
    { label: 'Blood Group',             field: 'BloodGroup' },
    { label: 'Nominee',                 field: 'Nominee' },
    { label: 'Is Membership Expired',   field: 'IsMembershipExpires' },
    { label: 'Is Subscription Expired', field: 'IsSubscriptionExpires' },
    { label: 'Valid Member',            field: 'IsValidMember' },
    { label: 'Subscription Code',       field: 'Code' },
    { label: 'Subscription Name',       field: 'SubscriptionName' },
    { label: 'Active',                  field: 'Active' }
];

const ExportUserModal = (props) => {
    const [selectedColumns, setSelectedColumns] = useState(EXPORT_COLUMNS.map(c => c.field));
    const [format, setFormat]                   = useState('xlsx');

    useEffect(() => {
        $('#export-user-modal').modal({ backdrop: 'static' });
        $('#export-user-modal').on('hidden.bs.modal', function () {
            props.onDismissModal(false);
        });
        $('#export-user-modal').modal('show');
    }, []);

    const toggleColumn = (field) => {
        setSelectedColumns(prev =>
            prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]
        );
    };

    const selectAll   = () => setSelectedColumns(EXPORT_COLUMNS.map(c => c.field));
    const deselectAll = () => setSelectedColumns([]);

    const downloadHandler = async () => {
        if (selectedColumns.length === 0) {
            swal.fire({ icon: 'warning', titleText: 'Please select at least one column.', showConfirmButton: true });
            return;
        }

        swal.fire({
            titleText: 'Preparing download...',
            text: 'Please wait',
            showConfirmButton: false,
            allowOutsideClick: false,
            onOpen: () => swal.showLoading(),
        });

        try {
            const blob = await downloadUsers(selectedColumns, format);
            const url  = window.URL.createObjectURL(blob);
            const a    = document.createElement('a');
            a.href     = url;
            a.download = `users.${format}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            swal.close();
            $('#export-user-modal').modal('hide');
        } catch (err) {
            if (err.status === 403) {
                swal.fire({
                    icon              : 'error',
                    titleText         : 'Export Access Denied!',
                    text              : 'You do not have permission to export user data.',
                    buttonsStyling    : false,
                    confirmButtonClass: 'btn btn-brand',
                });
            } else {
                swal.fire({
                    icon              : 'error',
                    titleText         : 'Error!',
                    text              : err.message,
                    buttonsStyling    : false,
                    confirmButtonClass: 'btn btn-brand',
                });
            }
        }
    };

    return (
        <div id="export-user-modal" className="modal fade" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Download Users</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <div className="d-flex align-items-center justify-content-between margin-b10">
                                <label className="col-form-label padding-0"><strong>Select Columns</strong></label>
                                <div>
                                    <button type="button" className="btn btn-sm btn-secondary margin-r5" onClick={selectAll}>Select All</button>
                                    <button type="button" className="btn btn-sm btn-secondary" onClick={deselectAll}>Deselect All</button>
                                </div>
                            </div>
                            <div className="row">
                                {EXPORT_COLUMNS.map(col => (
                                    <div key={col.field} className="col-md-4 col-sm-6 margin-b10">
                                        <label className="kt-checkbox kt-checkbox--brand">
                                            <input
                                                type="checkbox"
                                                checked={selectedColumns.includes(col.field)}
                                                onChange={() => toggleColumn(col.field)}
                                            />
                                            {col.label}
                                            <span></span>
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="form-group margin-t10">
                            <label><strong>Format</strong></label>
                            <div className="d-flex margin-t5">
                                <label className="kt-radio kt-radio--brand margin-r20">
                                    <input
                                        type="radio"
                                        name="exportFormat"
                                        value="xlsx"
                                        checked={format === 'xlsx'}
                                        onChange={() => setFormat('xlsx')}
                                    />
                                    Excel (.xlsx)
                                    <span></span>
                                </label>
                                <label className="kt-radio kt-radio--brand">
                                    <input
                                        type="radio"
                                        name="exportFormat"
                                        value="csv"
                                        checked={format === 'csv'}
                                        onChange={() => setFormat('csv')}
                                    />
                                    CSV (.csv)
                                    <span></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-brand margin-0"
                            onClick={downloadHandler}
                            disabled={selectedColumns.length === 0}
                        >
                            <i className="la la-download"></i> Download
                        </button>
                        <button type="button" className="btn btn-secondary margin-0 margin-r5" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExportUserModal;
